import { useTranslation } from 'react-i18next';

import Modal from '../../common/Modal';
import ModalButton from '../../common/ModalButton';
import { hasMidi } from '../../../utils/midiJson';

import './PartOptionsModal.scss';

const PartOptionsModal = ({
  isOpen,
  onClose,
  part,
  onCopy,
  onEdit,
  // Given only where the part can be set in the intensity panel
  onEditIntensity,
  onPlayMidi,
  onPlayChart,
  hasChart,
  isAdmin,
}) => {
  const { t } = useTranslation();

  if (!part) return null;

  const handleCopy = () => {
    onCopy(part);
    onClose();
  };

  const handlePlayMidi = () => {
    onPlayMidi(part);
    onClose();
  };

  const handlePlayChart = () => {
    onPlayChart(part);
    onClose();
  };

  const handleEdit = () => {
    onEdit(part);
    onClose();
  };

  const handleEditIntensity = () => {
    onEditIntensity(part);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${t(`parts.${part.name}`, { defaultValue: part.name })} ${part.number}`}
      className="PartOptionsModal"
    >
      <div className="actions">
        {isAdmin && (
          <ModalButton block onClick={handleCopy}>
            {t('dialogs.partOptions.copyLyrics')}
          </ModalButton>
        )}
        {hasMidi(part) && (
          <ModalButton block onClick={handlePlayMidi}>
            {t('dialogs.partOptions.playMidi')}
          </ModalButton>
        )}
        {hasChart && (
          <ModalButton block onClick={handlePlayChart}>
            {t('dialogs.partOptions.playChart')}
          </ModalButton>
        )}
        {isAdmin && (
          <ModalButton block onClick={handleEdit}>
            {t('dialogs.partOptions.editPart')}
          </ModalButton>
        )}
        {isAdmin && onEditIntensity && (
          <ModalButton block onClick={handleEditIntensity}>
            {t('dialogs.partOptions.intensity')}
          </ModalButton>
        )}
      </div>
    </Modal>
  );
};

export default PartOptionsModal;
